//Compress this file with below mentioned online tool
// https://codebeautify.org/jsviewer

AUI().ready(

            /*
            This function gets loaded when all the HTML, not including the portlets, is
            loaded.
            */
			function() {
				console.log("ucmLocale----" + ucmLocale);
				if(ucmLocale !="en-CHN" && ucmLocale!="cn-CHN"){
					dataLayer.push({
                        'event':'LiferayVirtualPageview',
                        'LiferayPageURL': window.location.pathname.concat(window.location.search),
                        'LiferayPageTitle': document.title
                        });
				}
      }
);

Liferay.Portlet.ready(

	/*
	This function gets loaded after each and every portlet on the page.

	portletId: the current portlet's id
	node: the Alloy Node object of the current portlet
	*/

	function(portletId, node) {
	}
);

Liferay.on(
	'allPortletsReady',

	/*
	This function gets loaded when everything, including the portlets, is on
	the page.
	*/

	function() {
	}
);

$( "#closeCookieBanner" ).click(function() {
  $("#header-msg-wrapper").hide();
});



/**
* Clearable text inputs
*/

$(".clearable").each(function() {
  
  var $inp = $(this).find("input:text"),
      $cle = $(this).find(".clearable__clear");

  $inp.on("input", function(){
    $cle.toggle(!!this.value);
  });
  
  $cle.on("touchstart click", function(e) {
    e.preventDefault();
    $inp.val("").trigger("input");
  });
  
});





function setCookie(cname, cvalue, exdays, domain) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
	var domainSet = "domain="+ domain;
	if(typeof domain === 'undefined' || domain === null){
		domainSet = "";
	}
	document.cookie = cname + "=" + cvalue + ";" + expires + ";" + domainSet +";path=/";
}


function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}


//console.log("ucmLocale : " + ucmLocale);
var UCMSiteLanguage = ucmLocale.substr(0, ucmLocale.indexOf("-"));
var bcookieName = 'bannercookie_'+ UCMSiteLanguage;
var baseUrl = Liferay.ThemeDisplay.getCDNBaseURL();
var domainForCookie = baseUrl.substr(baseUrl.indexOf("."));
//Set cookie for language change
setCookie("multi_country",ucmLocale,365,domainForCookie);

var banner_display = getCookie(bcookieName);
				if(banner_display == null || banner_display === '') 
				{
					$("#header-msg-wrapper").show();
					setCookie(bcookieName, 'Y', 10, domainForCookie);				
				}
				else
				{
					$("#header-msg-wrapper").hide();
				}
				
				
// Js from Pallavi				


function getRecentSearchCookie(cname){
		
							var name=cname+"=";
							var decodedCookie=decodeURIComponent(document.cookie);
							var ca=decodedCookie.split(';');
							for(var i=0;i<ca.length;i++){
							var c=ca[i];
							while(c.charAt(0)==' '){
							c=c.substring(1)
							}
							if(c.indexOf(name)==0){
							return c.substring(name.length,c.length)
							}
							}
							return ""
							}
							
$('#browse-exp-btn_job').click(function(){$('#browse-exp_job').fadeIn(400);return!1});
$('#closeButton').click(function(e){e.preventDefault();this.parentNode.style.display = 'none'; return false});

/*$('#closeButton').addEventListener('click', function(e) {
    e.preventDefault();
 this.parentNode.style.display = 'none';
}, false);*/


function HAYSsearchjobshome_search_jobsGCSES(formName, searchURLPartial) {
	
	  var jobSearchURL= searchURLPartial;
	  var locationCountryAppender = '';
	  var searchForLocation = encodeURIComponent($('#'+formName+'locationToSearch').val());
	  var qVal = encodeURIComponent($('#'+formName+'q').val());
	//  SetCookie("recentSearch",qVal,365);
	var searchUrl = jobSearchURL+"/search/";
	  var locationHrefGCS = searchUrl+"?q="+qVal+"&location="+searchForLocation;
	
	  window.location.href =locationHrefGCS;
	
	}		

//Added Js for job search validation
function HAYS_search_jobsGCSES(formName, searchURLPartial) {
	
	  var jobSearchURL= searchURLPartial;
	  var locationCountryAppender = '';
	  var searchForLocation = encodeURIComponent($('#'+formName+'locationToSearch').val());
	  var qVal = encodeURIComponent($('#'+formName+'q').val());
	//  SetCookie("recentSearch",qVal,365);
	  var searchUrl = jobSearchURL+"/search/";
	
	  if(searchForLocation == "" || qVal == "") {
		  $(".search-error-msg").show();
		  //alert('Enter atleast one of the value to search..!');
		return false;
	  } 
	  
	  else {
	  var locationHrefGCS = searchUrl+"?q="+qVal+"&location="+searchForLocation;
	  window.location.href =locationHrefGCS;
	  }
}

function includeJQueryAutocompleteForKeywords(formName, formLocale) {
	
	 var siteLocale = formLocale; 
	
	 if (window.jQuery) {
	  var sourceRecentHistory = [];
	
	  var recentSearchTerm = getRecentSearchCookie("recentSearch");
	 
					if(recentSearchTerm != undefined){
						
						try {
							recentSearchTerm = decodeURIComponent(recentSearchTerm);
						} catch (ex) {
							//console.log("Error in decoding");
						}
						if (recentSearchTerm) {
							var finalRS = [];
							finalRS = recentSearchTerm.split("|");
							sourceRecentHistory = finalRS;
							//alert('sourceRecentHistory'+sourceRecentHistory);
							
						}
					}
	
					var sourceBlank = [];
					$('#'+formName+'q').autocomplete({
						minLength:3,
						source: function(request, response) {
							
								if(request.term.length == 0){
									$(".ui-autocomplete").addClass("history").removeClass("suggestion");
									response(sourceRecentHistory)
									}
								else if (request.term.length >0 && request.term.length < 3){
									response(sourceBlank)}
								else{
									//console.log("hit recorder for GCS");
									if(formLocale !="en-CHN" && formLocale !="cn-CHN"){
										dataLayer.push({
											'event':'googleAutoSuggest',
											'GCJAutoSuggest':request.term
										});	
									}
									
									$(".ui-autocomplete").addClass("suggestion").removeClass("history");
									 $.ajax({
						                 url : pathContext+"/o/KeywordRest/keywords/"+request.term,
						                 type : "GET",
						                    data : {
						                        limit: 5,
						                             completionType: 'JOB_TITLE',
						                             locale: siteLocale
						                 },
						                 dataType : "json",
						                 success : function(data) {
						                       response(data.list,function(item){
						                    	   
						                           return{
						                                //item
						                                label: item,
									        value: item
						                              //alert("success");
						                           }
						                       })
						                 }, 
						                 error: function(jqXHR, textStatus, errorThrown){
                                        $(".ui-autocomplete-loading").removeClass("ui-autocomplete-loading");
                                        //console.log("error handler!");
                                        response(sourceBlank)
                                        //response(sourceRecentHistory);
										}
						          });
								
									}
						},
						select: function(event, ui) {
						$('#'+formName+'q').attr('value', ui.item.value); 
					},
						open: function() {
							$(this).removeClass("ui-corner-all").addClass("ui-corner-top");
						},
						close: function() {
							$(this).removeClass("ui-corner-top").addClass("ui-corner-all");
						}
						})
					 .focus(function() {
							if($(this).val() == ""){
	                       $(this).autocomplete("search", $(this).val());
	                       //console.log("inside focus");
						    }
				
							});
							}
							else {
								window.setTimeout(includeJQueryAutocompleteForKeywords, 100);
							}
	 
	 
						}


function includeJQueryAutocompleteForLocations(formName) {
							
							 if (window.jQuery) {
							 
											var sourceBlank1 = [];
											$('#'+formName+'locationToSearch').autocomplete({
												minLength:3,
												source: function(request, response) {
														if(request.term.length == 0){
															//console.log("inside if when term length 0");
															}
														else if (request.term.length >0 && request.term.length < 3){
															response(sourceBlank1)}
														else{
															$(".ui-autocomplete").addClass("suggestion").removeClass("history");
															 $.ajax({
												                 url : pathContext+"/o/LocationSuggestions/hayslocation/domain/"+domainId+"/"+rowNum+"/"+encodeURI(request.term),
												                 type : "GET",
												                 dataType : "json",
												                 success : function(data) {											                	 
												                	 var items = [];

												                     $.each( data.results, function(key, val){
												                         items.push(val.LOCATION_DESC);
												                     });

												                     //console.log(items);
												                     response(items);
												                     
												                 }, 
												                 error: function(err){
												                //console.log("error handler!");
												                
												                 }
												          });
														
															}
												},
												select: function(event, ui) {
												$('#'+formName+'locationToSearch').attr('value', ui.suggestion );
											},
												open: function() {
													$(this).removeClass("ui-corner-all").addClass("ui-corner-top");
												},
												close: function() {
													$(this).removeClass("ui-corner-top").addClass("ui-corner-all");
												}
											}).focus(function() {
							    $(".sample1").addClass("test");
								$(this).autocomplete("search", $(this).val());});	
											
											
											
													}
													else {
														window.setTimeout(includeJQueryAutocompleteForLocations, 100);
													}
							 
							 
												}

function HAYSsearchjobsSpecialism_search_jobsGCSES(formName, searchURLPartial, specialismType) {
	
	  var jobSearchURL= searchURLPartial;
	
	  var locationCountryAppender = '';
	  var searchForLocation = $('#'+formName+'locationToSearch').val();
	  var qVal = $('#'+formName+'q').val();
	
	  var searchUrl = jobSearchURL+"/search/";
	  var locationHrefGCS = searchUrl+"?q="+qVal+"&location="+searchForLocation;
	  var specialism_exists_checkGCS = $('#'+formName+'x_specialism').val();
	 
	  var subSpecialismValJS="";
	
	  var specialismCategoryCheck= specialismType;
	 
	  if (specialism_exists_checkGCS !=""){
			if (document.getElementById(formName+"x_search").checked == true ){
				 if (specialismCategoryCheck === "specialism") {
					  
					  locationHrefGCS = locationHrefGCS+"&specialismId="+specialism_exists_checkGCS+"&subSpecialismId="+ subSpecialismValJS;
				
				 }
				  else if (specialismCategoryCheck === "subspecialism"){
					 
					  locationHrefGCS = locationHrefGCS+"&specialismId="+subSpecialismValJS+"&subSpecialismId="+ specialism_exists_checkGCS;
			
				  }
				
				
				
			}
		}
	
	  window.location.href =locationHrefGCS;
}

function HAYSsite_search(formName, searchURL, currFrndlyURL) {
                var queryText = $('#'+formName+'QueryText').val();
                if(queryText=='' || queryText==null){
                 document.getElementById("siteSearchErrorLabel").style.display = "block";
                }
                else{
                var currentLayoutURL = Liferay.ThemeDisplay.getLayoutURL()+"/";
                var searchHref = currentLayoutURL.replace(currFrndlyURL+"/", searchURL +queryText );
                //console.log("searchHref::"+searchHref);
                window.location.href =searchHref;
                }
                }



				//Tanya's code
				

/*function getCookie(c_name)
     {
    var i,x,y,ARRcookies=document.cookie.split(";");
    //console.log("ARRcookies"+ARRcookies);
      for (i=0;i<ARRcookies.length;i++)
      {
        x=ARRcookies[i].substr(0,ARRcookies[i].indexOf("="));
        y=ARRcookies[i].substr(ARRcookies[i].indexOf("=")+1);
        x=x.replace(/^\s+|\s+$/g,"");
        //console.log("x"+x);
        if (x==c_name)
       {
       return unescape(y);
       }
      } 
     }

var username=getCookie("usrname");
console.log("++++username----"+decodeURIComponent(escape(username)));
function functionalityCookie(){ 
if(window.jQuery && jQuery.ui && jQuery.isReady) 
{
//console.log("if loop in functional cookie");
var showusername = $(".usr-unhidden");
var hideusername = $(".usr-hidden col-lg-12");
if (username == null || username.length <= 0 || username === undefined)
{
//console.log("nested if  loop in functional cookie");
showusername.hide();
hideusername.show();
}
else
{
//console.log("username"+username);
//console.log("username++++"+decodeURIComponent(escape(username)));
var nameOfPerson = decodeURIComponent(escape(username)).replace(/\+/g, ' ');
//var nameOfPerson = username.replaceAll('+', ' ');   //Name of person
console.log("username---"+nameOfPerson);
document.getElementById("user").textContent = nameOfPerson;
showusername.show();
$('.usr-hidden').hide();

}
}
else 
				{
					window.setTimeout(functionalityCookie, 100);
				}


};                                                                             
functionalityCookie();  
*/

// code  by Ankush


$(document).keypress(function(event){
var x=document.activeElement.id;
           var keycode = (event.keyCode ? event.keyCode : event.which);
            if(keycode == '13'){       
            if (x=='site_searchQueryText') 
            {
            document.getElementById("analytic_site_srch_btn").click();
            }
            if (x=='home_search_candGCSq') 
            {
            document.getElementById("analytic_home_srch_btnGCS").click();
            }
            if (x=='home_search_candGCSlocationToSearch') 
            {
            document.getElementById("analytic_home_srch_btnGCS").click();
            }           
                        if (x=='QueryText') 
            {
            document.getElementById("featureEmployerfm").submit();
            }           
                        if (x=='specialism_search_candGCSq') 
            {
            document.getElementById("HAYSsearchjobsbutton").click();
            }
            
                        if (x=='specialism_search_candGCSlocationToSearch') 
            {
            document.getElementById("HAYSsearchjobsbutton").click();
            }
						if (x=='myLearningCourseSearchKeyword')
			{
			document.getElementById("myLearningCourseSearch").submit();
			}
		    if (x=='hero-search-input')
            {
                document.getElementById("candidateLandingSearch").submit();
            }

  $("form").submit(function(e){
        e.preventDefault();
    });
            
            }
});






//  nav menu toggle on home page 

 $(document).ready(function(){

    $('.expandable-in-mobile h3').click(function(e) {
        if ($(this).parents('.expandable-in-mobile').hasClass('active')) {
            $(this).parents('.expandable-in-mobile').removeClass('active')
        } else {
            $(this).parents('.expandable-in-mobile').addClass('active')
        }
    });
    
    $('.exp-list > li').each(function() {
        if ($(this).children('ul').length > 0) {
            $(this).addClass('expandable')
        }
    });

 	 
	 
 });
 
//Manage Hero area height 
/* $(document).ready(function(){
   if($('body').prop('id') != "HaysSearchEntity"){
       var height=354+$("#hero-area-content #banner-heading").height()-122;
       $("#hero-area-image").height(height);$("#hero-area").height(height);$("#hero-area-content").height(height);$("#heroAreaCarousel .carousel-inner .aspect-ratio").height(height);
            }
});*/

 // This is for old home page
 $(document).ready(function(){
	   if(!$('body').hasClass( "HaysSearchEntity")){
	       var height=354+$("#hero-area-content #banner-heading").height()-122;
	console.log("new height is "+ height);
	       $("#hero-area-image").height(height);$("#hero-area").height(height);$("#hero-area-content").height(height);$("#heroAreaCarousel .carousel-inner .aspect-ratio").height(height);
	            }
	});

	
// Career advice mobile dropdown
	$(document).ready(function(){
		$("#dropdown-select").click(function(){
			$(".dropdown-select-items").toggleClass("show-dropdown");
			$(".nav-item").click(function(){
			 let cat = $(this).attr("data-tab-name");
			 document.getElementById("dropdown-select").innerHTML=cat;
			 $(this).parent().parent().removeClass("show-dropdown");
			});
		});
	});
	document.addEventListener('click', function(event) {
			if (!event.target.matches('#dropdown-select')) {
				if ($('.dropdown-select-items').hasClass('show-dropdown') == true) {
					$(".dropdown-select-items").removeClass("show-dropdown");		
				}
			}
	});

	
	
// Career advice and events mobile dropdown
	$(document).ready(function(){
		$("#dropdown-select-option").click(function(){
			$(".select-drop-down-items").toggleClass("show-dropdown");
			$(".nav-item").click(function(){
			 let cat = $(this).attr("data-tab-name");
			 document.getElementById("dropdown-select-option").innerHTML=cat;
			 $(this).parent().parent().removeClass("show-dropdown");
			});
		});
	});
	document.addEventListener('click', function(event) {
			if (!event.target.matches('#dropdown-select-option')) {
				if ($('.select-drop-down-items').hasClass('show-dropdown') == true) {
					$(".select-drop-down-items").removeClass("show-dropdown");		
				}
			}
	});

		// Hays Insight mobile dropdown
	$(document).ready(function(){
		$("#dropDownValue").click(function(){
			$(".dropdownSelect-items").toggleClass("show-dropdown");
			$(".nav-item").click(function(){
			 let cat = $(this).attr("data-tab-name");
			 document.getElementById("dropDownValue").innerHTML=cat;
			 $(this).parent().parent().removeClass("show-dropdown");
			});
		});
	});
	document.addEventListener('click', function(event) {
			if (!event.target.matches('#dropDownValue')) {
				if ($('.dropdownSelect-items').hasClass('show-dropdown') == true) {
					$(".dropdownSelect-items").removeClass("show-dropdown");		
				}
			}
	});

	
	
	
	
// User current location in search


$(".getlocationpref").click(function(){
	if (navigator.geolocation) {
		navigator.geolocation.getCurrentPosition((position)=>{
			const longitude = position.coords.longitude;
			const latitude = position.coords.latitude;
			console.log(latitude,longitude,'current location');
			callApi(longitude, latitude);
		});
	} else {
		console.log("No support for geolocation")
	}
});

function callApi(Longitude, Latitude){
    var geocoder;
	var town = '';
    geocoder = new google.maps.Geocoder();
    var latlng = new google.maps.LatLng(Latitude, Longitude);
    geocoder.geocode({'latLng': latlng},function(results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			if (results[0]) {
				if (results[0].address_components[2].types[0] === 'postal_town') {
					town = results[0].address_components[2].long_name;
				} else {
					results[0].address_components.forEach(function(address_component){
						var typeIndex = address_component.types.indexOf('postal_town');
						if(address_component.types[typeIndex] === 'postal_town') {
							town = address_component.long_name;
							return false;
						}
					});	
				}
				var add = results[0].formatted_address ;
				var value = add.split(",");
				let count = value.length;
				let country = value[count-1];
				let final_location = town !== '' ? town + ", " + country : country;
				$("#home_search_candGCSlocationToSearch").val(final_location);
				$("#home_search_candGCSlocationToSearch_mobile").val(final_location);
			}
			else  {
				console.log("address not found");
			}
		}
		else {
		   console.log( "Geocoder failed due to: ",status);
		}
	});
}

  
function includeJQueryAutocompleteForMyLearningSuggestions(formName, portalURL) {
   if (window.jQuery) {
     var sourceRecentHistory = [];
    var recentSearchTerm = getRecentSearchCookie("recentSearch");
      if(recentSearchTerm != undefined){
         try {
             recentSearchTerm = decodeURIComponent(recentSearchTerm);
          } catch (ex) {
             //console.log("Error in decoding");
          }
          if (recentSearchTerm) {
             var finalRS = [];
             finalRS = recentSearchTerm.split("|");
             sourceRecentHistory = finalRS;
             //alert('sourceRecentHistory'+sourceRecentHistory);
         }
       }
      var sourceBlank = [];
       $('#'+formName+'Keyword').autocomplete({
          minLength:3,
          source: function(request, response) {
               if(request.term.length == 0){
                   $(".ui-autocomplete").addClass("history").removeClass("suggestion");
                   response(sourceRecentHistory)
                   }
                else if (request.term.length >0 && request.term.length < 3){
                   response(sourceBlank)
                        } else {
                   $(".ui-autocomplete").addClass("suggestion").removeClass("history");
                           console.log(request.term); 
                                $.ajax({
                                     url : portalURL + "/o/go1service/suggestions/5/term/" + request.term,
                                     type : "GET",
                                     dataType : "json",

                                  success : function(data) {
                                     console.log(data.result);
                                           response(data.result,function(item){
                                               return {
                                                    label: item.value,
                                                    value: item.value
                                               }
                                           })
                                     },
                                     error: function(jqXHR, textStatus, errorThrown){
                                    $(".ui-autocomplete-loading").removeClass("ui-autocomplete-loading");
                                    response(sourceBlank)
                                    }
                                 });

                  }
          },
          select: function(event, ui) {
          $('#Query'+formName).attr('value', ui.item.value);
       },
          open: function() {
             $(this).removeClass("ui-corner-all").addClass("ui-corner-top");
          },
          close: function() {
             $(this).removeClass("ui-corner-top").addClass("ui-corner-all");
          }
          })
        .focus(function() {
             if($(this).val() == ""){
                  $(this).autocomplete("search", $(this).val());
              }
             });
             }
             else {
                window.setTimeout(includeJQueryAutocompleteForMyLearning, 100);
             }
}  





function validateForm(formId, fieldId, errorMessage) {
   var x = document.forms[formId][fieldId].value;
   if (x==null || x=="") {
      document.getElementById("name_error").innerHTML = errorMessage;
      return false;
   }
}

// Function for country dropdown show-hide

$(document).ready(function(){
	$('.nav-dropdown-button--country').click(function(){
		$('.nav-dropdown-country').toggleClass('d-block')
	})
})

// Toast js

$(document).ready(function(){
    const $close = document.querySelector('[data-js="close-toast"]');
    const $toast = document.querySelector('[data-js="cta-toast"]');
  
    const close = () => {
      $toast.classList.remove('d-flex');
      $toast.classList.add('d-none');
    };
  
    const init = () => {
      $close.addEventListener('click', close);
    };
  
    if ($toast) init();
  });

// Jumpmenu js
  
$(document).ready(function(){
  const $mainToggle = document.querySelector('[data-js="jump-link-toggle"]');
  const $moreToggle = document.querySelectorAll(
    '[data-js="jump-link-more-toggle"]'
  );

  const openToggle = ($el) => {
    if ($el.classList.contains('is-open')) {
      $el.classList.remove('is-open');
    } else {
      $el.classList.add('is-open');
    }
  };

  const init = () => {
    $mainToggle.addEventListener('click', () => openToggle($mainToggle));

    for (let i = 0; i < $moreToggle.length; i++) {
      $moreToggle[i].addEventListener('click', () =>
        openToggle($moreToggle[i])
      );
    }
  };

  if (!!$mainToggle) init();
});


// read-more js

$(document).ready(function(){
  const $open = document.querySelector('[data-js="open-read-more"]');
  const $container = document.querySelector('[data-js="read-more"]');

  const open = () => {
    $container.classList.add('is-open');
    $open.classList.add('d-none');
  };

  const init = () => {
    // open on load if textarea is under a certain height
    if ($container.offsetHeight < 480) {
      open();
    }
    $open.addEventListener('click', open);
  };

  if ($open) init();
});

// search js

$(document).ready(function(){
    console.log('search.js loaded');
    const $open = document.querySelector('[data-js="open-search"]');
    const $openMobile = document.querySelector('[data-js="open-search-mobile"]');
    const $close = document.querySelector('[data-js="close-search"]');
    const $search = document.querySelector('[data-js="search"]');
    // trigger to close the search if nav is opened
    const $hamburger = document.querySelector('[data-js="nav-toggle"]');

    const open = () => {
        $open.classList.add('is-open');
        $openMobile.classList.add('is-open');
        $search.classList.remove('d-none');
    };

    const close = () => {
        $open.classList.remove('is-open');
        $openMobile.classList.remove('is-open');
        $search.classList.add('d-none');
    };

    const handleTriggerClick = () => {
        if ($open.classList.contains('is-open')) {
            close();
        } else {
            open();
        }
    };

    const init = () => {
        $open.addEventListener('click', handleTriggerClick);
        $openMobile.addEventListener('click', handleTriggerClick);
        $close.addEventListener('click', close);
        $hamburger.addEventListener('click', close);
    };

    if ($open) init();
});


// navigation js

$(document).ready(function(){
    const $hamburger = document.querySelector('[data-js="nav-toggle"]');
    const $body = document.querySelector('body');
    const $dropdownTriggers = [
        ...document.querySelectorAll('[data-js="menu-dropdown-trigger"]')
    ];
    // trigger to close the nav if search is opened
    const $openMobile = document.querySelector('[data-js="open-search-mobile"]');

    const open = () => {
        $body.classList.add('is-locked');
        $hamburger.classList.add('is-open');
    };

    const close = () => {
        // prevent scrolling by locking the body
        // with overflow: hidden;
        $body.classList.remove('is-locked');
        $hamburger.classList.remove('is-open');

        // close all dropdowns when closing nav
        $dropdownTriggers.map(($trigger) => {
            $trigger.classList.remove('is-open');
        });
    };

    const toggleNavIsOpen = (e) => {
        const isOpen = $hamburger.classList.contains('is-open');

        if (isOpen) {
            close();
        } else {
            open();
        }
    };

    /**
     *
     * @param {HTMLElement} $trigger Dropdown trigger
     */
    const toggleDropdown = ($trigger) => {
        const isOpen = $trigger.classList.contains('is-open');

        if (isOpen) {
            $trigger.classList.remove('is-open');
        } else {
            $trigger.classList.add('is-open');
        }
    };

    const init = () => {
        $openMobile.addEventListener('click', close);
        $hamburger.addEventListener('click', toggleNavIsOpen);
        $dropdownTriggers.map(($trigger) => {
            $trigger.addEventListener('click', (e) => {
                e.preventDefault();
                toggleDropdown(e.currentTarget);
            });
        });
    };

    if ($hamburger) init();


    // add data-senna-off for project s links
    var jobPortalPagesVal = $("#jobPortalPages").val();
    var projectSContextsArray = jobPortalPagesVal.split(',');
    $('a').each(function() {
    	var href = $(this).attr('href');
    	for(var i=0; i< projectSContextsArray.length; i++)
    		{
    			if ((href != undefined) && (href != '#') && href.indexOf(projectSContextsArray[i]) != -1) {
    				$(this).attr('data-senna-off', 'true');
    			}
    		}
    });

});

// Change meu navigation hover to click

$(document).on("click", (function(event) {
	if(!$(".nav-dropdown-hamburger").hasClass('is-open')){
        let $target = $(event.target);
        if(!$target.closest('.nav-dropdown-trigger-link').length &&
            $('.nav-dropdown-menu').is(":visible")) {
            $('.nav-dropdown-trigger-link').removeClass('is-open');
        }
	}
}));

$(document).ready(function(){
	$('.nav-dropdown-trigger-link ').click(function(){
		if(!$(".nav-dropdown-hamburger").hasClass('is-open')){
            $('.nav-dropdown-list .nav-dropdown-trigger a').removeClass("is-open");
            $(this).addClass("is-open");
        }
        else
        {
            if($('.nav-dropdown-trigger-link.is-open').length == 2){ //Quick fix for mobile menu nav dropdown minimizing issue
                $('.nav-dropdown-list .nav-dropdown-trigger a').removeClass("is-open");
                $(this).addClass("is-open");
            }
        }
	});
});



//Share Modal

 $(document).ready(function(){
    	var href=$("a.business-header.bg-white").attr('href');
    	 if(href != null){
    		console.log("href",href);
    		$(".logo-href").attr('href',href)
    		}

	$('.nav-dropdown-hamburger').click(function(){
 		if($(".nav-dropdown-hamburger").hasClass('is-open')){
            $('#div-ele').removeClass("active");
        }
       	});

    });

$(document).on('click', '.nav-dropdown-trigger-link', function() {
   var $triggerLink = $(this);
   var $dropdownMenu = $triggerLink.next('.nav-dropdown-menu');

   if (! $dropdownMenu.hasClass('open')) {
       // Remove the 'is-open' class from the clicked link
       $triggerLink.removeClass('is-open');
   } else {
       console.log('Dropdown is open');
   }
});

let timeout;

const observer = new MutationObserver(() => {
    if (window.hj && typeof window.hj === 'function' && window.hjSiteSettings?.polls) {
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            const hj = document.querySelector('._hj-widget-container, ._hj-widget-theme-light');
            if (hj) {
               document.body.classList.add('hotjar-enabled');
            }
            observer.disconnect();
        }, 1000);
    }
});

window.onload = function() {
    observer.observe(document.body, {childList: true});
};

$(document).ready(function(){
    const referrer = document.referrer.length > 0 ? document.referrer.split('/')[2] : '';
    const now = new Date().getTime();
    const expiryTime = now + 24 * 60 * 60 * 1000;
    const itemFromStorage = JSON.parse(localStorage.getItem('referer'));
    const item = {
        value: referrer,
        expiry: expiryTime
    }

    if (itemFromStorage){
        if(now > itemFromStorage.expiry){
            localStorage.removeItem('referer')
        }
        if (referrer && !referrer.includes('hays') && !itemFromStorage.value.includes(referrer)){
            localStorage.removeItem('referer')
            localStorage.setItem('referer', JSON.stringify(item));
        }
    }
    else{
        if (referrer) {
            if (!referrer.includes('hays')){
                localStorage.setItem('referer', JSON.stringify(item));
            }
        } else {
            localStorage.setItem('referer', JSON.stringify({
                value : 'Direct',
                expiry: expiryTime
            }));
        }
    }
});